import { useMemo } from 'react';
import { Country } from '@tiendanube/common/src/enums';
import { useResponsive } from 'commons/components';
import { useGetCountry } from 'domains/Auth/hooks';

const VALID_COUNTRIES_FOR_NUVEM_DOMAINS = [Country.MX];

export function useHasNuvemDomainEnabled() {
  const country = useGetCountry();
  const { isDesktop } = useResponsive();

  const isEnabled = useMemo(() => {
    const isCountryValid = VALID_COUNTRIES_FOR_NUVEM_DOMAINS.includes(country);
    return isCountryValid && isDesktop;
  }, [country, isDesktop]);

  return isEnabled;
}
